import PropTypes from 'prop-types';
import CmsModules from 'libs/storyblok/content/Modules';
import headerHeights from 'config/branding/header-heights';
import { addLocalePrefix } from '@activebrands/core-web/utils/add-locale-prefix';

const Page = ({ location, pageContext, previewDataOverride }) => {
    const data = previewDataOverride || pageContext?.page?.data;
    const heroContent = data?.content?.heroContent;
    const pageContent = data?.content?.pageContent;
    const localePrefix = addLocalePrefix('/');

    const { headerHeight } = headerHeights;

    // Dynamicly set the hero height based on the height of the banner and header
    const heroStyles = {
        marginTop: [`0px`, null, null, null, null, `${headerHeight}px`],
        height: `calc(100vh - ${headerHeight}px)`,
    };

    return (
        <>
            {heroContent && <CmsModules isHero modules={heroContent} $heroStyling={heroStyles} />}
            {pageContent && <CmsModules isHome={location?.pathname === localePrefix} modules={pageContent} />}
        </>
    );
};

Page.propTypes = {
    location: PropTypes.object,
    pageContext: PropTypes.object,
    previewDataOverride: PropTypes.object,
};

export default Page;
